let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hvCAw")).then(() => parcelRequire('f9SAR'));